package org.vreo.devicehub.features.device.presentation.deviceList

import org.vreo.devicehub.features.core.domain.device.device.AnprDevice

/**
 * Device list actions. Actions that can be performed by device list screen.
 */
sealed interface DeviceListActions {
    class OnClearError : DeviceListActions
    class OnUpdateDeviceList : DeviceListActions
    class OnDeviceSelect(val device: AnprDevice) : DeviceListActions
    class OnAddNewDevice() : DeviceListActions
    class OnRegisterNewDevice () : DeviceListActions
    class OnSaveProductionDeviceDetails() : DeviceListActions
    class OnClearConfirmDialog : DeviceListActions
    data class OnOpenUnlinkDeviceDialog(val device: AnprDevice) : DeviceListActions
    data class OnOpenDeleteDeviceDialog(val device: AnprDevice) : DeviceListActions
    class OnUnlinkConfirm : DeviceListActions
    class OnDeleteConfirm : DeviceListActions
    data class OnAdminViewToggleUpdate(val value: Boolean) : DeviceListActions
}